/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */

import React from 'react';
import './hints.sass';

const icon = type => <span className={`fa fa-${type}`} />;

export const AsideSearchHints = {
  searchImageHint: {
    hint: (
      <div className="custom-hint-content">
        <p>
          Click <span className="btn-style">Search Images</span> to search for images contained within the range of the image search parameter provided in the belowing section.
          The search result will be shown in the right hand side and displayed as a grid of images.
        </p>
        <p>
          Click <span className="btn-style">Evaluate by Parameters</span> to search for the evaluation result of all images contained within the range of the image search parameter provided in the belowing section.
          It will fetch the evaluation result and visualized in <strong>histogram plot</strong> / <strong>box plot</strong> / <strong>radar chart</strong> (WIP)
        </p>
      </div>
    ),
    hintConfig: { style: { marginLeft: '10pt' } }
  },
  filterHint: {
    hint: (
      <div className="custom-hint-content">
        <p>
          If the option: <strong>Evaluated Images Only</strong> is active, it will filter out the non-evaluated images in the search result.
        </p>
      </div>
    ),
    hintConfig: { style: { marginLeft: '10pt' } }
  },
  sourceHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by the <strong>Data Source</strong>. For instance, the <strong>COCO</strong> data source.</p>
        <p>You can add data source by using the search input, it will automatically search for the desired options which you can choose directly from.</p>
        <p>You can also press the <span className="btn-style">Select All</span> or <span className="btn-style">Delete All</span> button for including / excluding all of the data sources in this input field.</p>
      </div>
    )
  },
  categoriesHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by the <strong>Object Categories</strong>. For instance, the <strong>person</strong> category.</p>
        <p>You can add object category by using the search input, it will automatically search for the desired options which you can choose directly from.</p>
        <p>You can also press the <span className="btn-style">Select All</span> or <span className="btn-style">Delete All</span> button for including / excluding all of the categories in this input field.</p>
      </div>
    )
  },
  cameraIDHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by Camera IDs.</p>
        <p>1. Input a Camera ID</p>
        <p>2. Hit <em>Enter</em> to add the Camera ID</p>
        <p>3. Repeat step 1. and 2. to add more if any</p>
        <p>The search result refreshes every time when a camera ID is added.</p>
      </div>
    )
  },
  batchIDHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by the <strong>Batch ID</strong>.</p>
        <p>You can search for specific batch ID using the input field, it will automatically search for the desired options which you can choose directly from.</p>
        <p>You can also press the <span className="btn-style">Delete All</span> button to clear all of the selection.</p>
      </div>
    ),
    hintConfig: { dialogueConfig: { style: { left: '-50pt' } } }
  },
  imageSNHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by Image Serial Numbers.</p>
        <p>1. Input an Image SN</p>
        <p>2. Hit <em>Enter</em> to add the Image SN</p>
        <p>3. Repeat step 1. and 2. to add more if any</p>
        <p>The search result refreshes every time when an Image SN is added.</p>
      </div>
    ),
    hintConfig: { dialogueConfig: { style: { left: '-50pt' } } }
  },
  infraredModeHint: {
    hint: (
      <div className="custom-hint-content">
        <p>The <strong>Infrared Mode</strong> controls whether to filter out the IR mode images or not.</p>
        <p>It contains 3 states to choose: <br /></p>
        <ul>
          <li>{icon('bookmark')} <strong>Ignore Mode</strong>: Don't care whether to include the IR mode images</li>
          <li>{icon('bookmark')} <strong>On</strong>: Only show the IR mode images</li>
          <li>{icon('bookmark')} <strong>Off</strong>: Do not show the IR mode images</li>
        </ul>
        <p>See <a href="https://en.wikipedia.org/wiki/Infrared">Wikipedia</a> for more information about Infrared.</p>
      </div>
    ),
    hintConfig: { dialogueConfig: { position: 'top' } }
  },
  imageSizeHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by the <strong>size of the image</strong>.</p>
        {/* <p>You are able to drag the sliders to adjust the value of both dimensions.</p> */}
        {/* <p>There are also some default sizes provided for you to search specific sizes of the image - <strong>1440 X 960</strong>, <strong>1200 X 800</strong> ...etc.</p> */}
        <p>Default mode is <strong>Range</strong> mode, however, there are 3 modes provide for searching images:</p>
        <ul>
          <li>{icon('bookmark')} <strong>Range Mode</strong>: Search images within range according to the sliders</li>
          <li>{icon('bookmark')} <strong>Maximum Mode</strong>: Search images within range 0 X 0 to the maximum value according to the sliders</li>
          <li>{icon('bookmark')} <strong>Exact Mode</strong>: Search images only with size according to the sliders.</li>
        </ul>
      </div>
    ),
    hintConfig: { dialogueConfig: { position: 'top' } }
  },
  imageTimeHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Search images by the <strong>creation time of the image</strong>. Currently, this feature is under construction.</p>
        {/* <p>You are able to use the timepicker to determine both <strong>starting time</strong> and <strong>ending time</strong>.</p> */}
        {/* <p>There are also some default timing provided for you to search - <strong>Within 3 Days</strong>, <strong>Within a Month</strong> and <strong>Within a Year</strong> ...etc.</p> */}
      </div>
    ),
    hintConfig: { dialogueConfig: { position: 'top' } }
  }
};

export const TopBarHints = {
  gridListHint: (
    <div className="custom-hint-content">
      <p>Grid and list mode hint.</p>
    </div>
  ),
  gridImageSizeHint: {
    hint: (
      <div className="custom-hint-content">
        <p>You can adjust the size of the grid images using this switch.</p>
        <p>This switch provides 3 mode for displaying <strong>small</strong> / <strong>medium</strong> / <strong>large</strong> images from left to right.</p>
        <p>Default is the <strong>Medium</strong> size of the image.</p>
      </div>
    ),
    hintConfig: {
      display: 'dialogue',
      dialogueConfig: {
        style: {
          left: '-170pt',
          width: '200pt'
        }
      }
    }
  }
};

export const SingleImageEvaluationHints = {
  segmentation: {
    toggleInstanceHint: {
      hint: (
        <div className="custom-hint-content">
          <p>This page shows how the <strong>labeled segmentation instance</strong> or <strong>bounding boxes</strong> drew on the image. Default shown information is the <strong>segmentation instances</strong> on the image.</p>
          <p>The toggle switches below show <strong>a list of object category</strong>.</p>
          <p>By toggling the switch you can <strong>show</strong> or <strong>hide specific object category.</strong></p>
          <p>You can also click the <span className="btn-style">Show All</span> or <span className="btn-style">Hide All</span> button for <strong>showing/hiding all of the object categories</strong>.</p>
        </div>
      ),
      hintConfig: { dialogueConfig: { style: { left: '-50pt', width: '200pt' } } }
    },
    visualizationConfigHint: {
      hint: (
        <div className="custom-hint-content">
          <p>The visualization configuration has the following features:</p>
          <ul>
            <li>{icon('bookmark')} You can <strong>show/hide the segmentation</strong> by toggling the <span className="btn-style">Segment</span> button.</li>
            <li>{icon('bookmark')} You can <strong>show/hide the bounding box</strong> by toggling the <span className="btn-style">Bounding Box</span> button.</li>
            <li>{icon('bookmark')} You can <strong>zoom in/out</strong> by clicking the <span className="btn-style">Zoom In</span> or <span className="btn-style">Zoom Out</span> buttons.</li>
            <li>{icon('bookmark')} You can <strong>adjust the brightness</strong> of the image by clicking the <span className="btn-style">Brighten</span> or <span className="btn-style">Darken</span> buttons.</li>
          </ul>
        </div>
      ),
      hintConfig: {
        display: 'dialogue',
        dialogueConfig: {
          style: {
            left: '-100pt',
            width: '200pt',
            maxHeight: '150pt',
            overflowY: 'auto',
            paddingBottom: '5pt'
          }
        }
      }
    }
  },
  evaluationRadarChart: {
    modelToggleHint: {
      hint: (
        <div className="custom-hint-content">
          <p>Radar chart consists of multiple model data, the below model togglers can toggle the appearance of the corresponded chart polygon.</p>
        </div>
      ),
      hintConfig: { dialogueConfig: { style: { left: '-50pt', width: '200pt' } } }
    }
  }
};

export const BatchEvaluationHints = {
  shared: {
    availableModelsHint: {
      hint: (
        <div className="custom-hint-content">
          <p>The following button togglers section provides list of trained model.</p>
          <p>Toggle different model buttons will show corresponding evaluation result of the images.</p>
          <p>However, some of the button toggled didn't change the chart may because the image set has no evaluation data evaluated by the model.</p>
        </div>
      ),
      hintConfig: {
        style: { marginLeft: '10pt' },
        dialogueConfig: { style: { width: '300pt' } }
      }
    },
    metricHints: {
      hint: (
        <div className="custom-hint-content">
          <p>The following describes the information of the metrics measured and visualized in the chart:</p>
          <ul>
            <li>{icon('bookmark')} <strong>Image Avg. Instance IOU</strong> is the average intersection over union of instances in the image.</li>
            <li>{icon('bookmark')} <strong>Image PR AUC</strong> is the area under PR curve (precision v.s. recall) of the image.</li>
            <li>{icon('bookmark')} <strong>Image ROC AUC</strong> is the area under ROC curve (true positive rate v.s. false positive rate) of the image.</li>
            <li>{icon('bookmark')} <strong>Pixel Accuracy</strong> is the total pixels correctly classified to each class over all class pixels.</li>
            <li>{icon('bookmark')} <strong>Pixel False Neg. Rate</strong> is the percentage of non-detected pixels that in fact should be detected.</li>
            <li>{icon('bookmark')} <strong>Pixel False Pos. Rate</strong> is the percentage of detected pixels that in fact should be non-detected.</li>
            <li>{icon('bookmark')} <strong>Pixel IOU</strong> is the intersection over union of total pixels for each class.</li>
          </ul>
        </div>
      ),
      hintConfig: {
        style: { marginLeft: '10pt' },
        dialogueConfig: { style: { width: '300pt' } }
      }
    },
    scaleAdjustmentHint: {
      hint: (
        <div className="custom-hint-content">
          <p>There are three options for changing the scales of the chart, the <strong>linear</strong> / <strong>exponential</strong> / <strong>inversed exponential</strong> scales.</p>
          <p>Default is the linear scale which uniformly divide the scales into 5 sections.</p>
          <p>The exponential scale follows the equation of <strong>x to the power of 10</strong>. It is mainly for measuring the target which the higher value, the better it preformed.</p>
          <p>While the inversed exponential scale follows the equation of <strong>x to the power of 0.2</strong>. It is mainly for measuring the counter target which the lower value, the better it performed.</p>
        </div>
      ),
      hintConfig: { dialogueConfig: { style: { width: '300pt' } } }
    }
  },
  histogramHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Histogram is the visualized of different metrics and models in each image plotted as a set of bars.</p>
        <p>It compares models performance in condition of same metric.</p>
      </div>
    ),
    hintConfig: {
      style: { marginLeft: '10pt' },
      dialogueConfig: { style: { width: '300pt' } }
    }
  },
  boxPlotHint: {
    hint: (
      <div className="custom-hint-content">
        <p>Box plot is the visualization of the model's total performance among a set of images (which is searched or queried by the parameter in the image search.)</p>
        <p>You can hover on different box plot result and it will show the following informations which are listed below:</p>
        <ul>
          <li>{icon('bookmark')} <strong>Max</strong> rate is the maximum value of the evaluated image set.</li>
          <li>{icon('bookmark')} <strong>Min</strong> rate is the minimum value of the evaluated image set.</li>
          <li>{icon('bookmark')} <strong>Median</strong> is the value separating the higher half of evaluated image set from the lower half.</li>
          <li>{icon('bookmark')} <strong>Q3</strong> stands for the <strong>75th percentile</strong> or <strong>3rd quartile</strong> of the evaluated image set.</li>
          <li>{icon('bookmark')} <strong>Q1</strong> stands for the <strong>25th percentile</strong> or <strong>1rd quartile</strong> of the evaluated image set.</li>
          <li>{icon('bookmark')} <strong>IQR</strong> stands for <strong>interquartile range</strong> which is the range from 3rd quartile to the 1st quartile.</li>
        </ul>
      </div>
    ),
    hintConfig: {
      style: { marginLeft: '10pt' },
      dialogueConfig: { style: { width: '300pt' } }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resources/hints.jsx